import React, { useEffect, useState } from 'react'
import {
  Card, CardHeader, CardContent, Container, CircularProgress,
  Grid, ImageList, ImageListItem, Link, Radio, Tooltip, Typography
} from '@material-ui/core'
import { AccountCircle, FlagRounded, OutlinedFlagRounded, Share, ShareOutlined } from '@material-ui/icons'
import DoneIcon from '@mui/icons-material/Done'
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt'
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import { blue, grey } from '@material-ui/core/colors'
// import Identicon from 'identicon.js'
import { useStyles } from '../styles'
import { useDatabase } from '../DatabaseContext'
import { useAdDatabase } from '../AdDatabaseContext'

import { getLocalDateTime, jumble } from '../utils'
import ErrorCard from './ErrorCard'
import ContinueCard from './ContinueCard'

function AdPostQuestionCard({ id }) {

  const classes = useStyles()
  const { curUser, posts, adPostQuestions, startPostQuestionTime, receivePostQuestionResponses, viewPostInQuestions } = useAdDatabase()
  const thisPost = posts[id]
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [expanded, setExpanded] = useState(false)
  const [hasRead, setHasRead] = useState(false)
  const [allSelectedMessage, setAllSelectedMessage] = useState('')
  const [questions, setQuestions] = useState([])
  // 7-point likert scale
  const [options,] = useState([
    '1 - Strongly disagree',
    '2',
    '3 - Neutral',
    '4',
    '5 - Strongly agree',
    'N/A'
  ])

  const handleRefresh = () => {
    setLoading(true)
    setError('')
    setExpanded(false)
    setHasRead(false)
    setAllSelectedMessage('')
    setQuestions(jumble(Object.values(adPostQuestions)).map(q => {
      return { ...q, selectedOption: '0' }
    }))
    startPostQuestionTime(id).then(_ => {
      setLoading(false)
    }).catch(err => {
      setError('Some error occurred. Please try again.')
      setLoading(false)
    })
  }

  const handleExpand = () => {
    if (!hasRead) {
      setHasRead(true)
      viewPostInQuestions(id).then(_ => {}).catch(err => {setHasRead(false)})
    }
    setExpanded(true)
  }

  const handleCollapse = () => {
    setExpanded(false)
  }

  const chooseOption = (index, op) => {
    setAllSelectedMessage('')
    setQuestions(prevQues => {
      let copy = [...prevQues]
      copy[index].selectedOption = op
      return copy
    })
  }

  const handleSubmit = async () => {
    setAllSelectedMessage('')
    for (let q of questions) {
      if (q.selectedOption === '0') {
        setAllSelectedMessage('Please answer all the questions')
        return
      }
    }
    let responses = questions.map(q => ({ id: q.id, selectedOption: Number.parseInt(q.selectedOption)}))
    try {
      await receivePostQuestionResponses(id, responses)
    } catch (err) {
      throw err
    }
  }


  const handleButtonClicking = () => {
    // This function does nothing
  };


  useEffect(() => {
    handleRefresh()
    // eslint-disable-next-line
  }, [id])

  return (
    <div className='AdPostQuestionCard' style={{ marginBottom: '90px' }}>
      <Container maxWidth='md'>
        {loading ?
          <div style={{ textAlign: 'center' }}>
            <CircularProgress color='secondary' />
          </div> :
          error ?
            <ErrorCard message={error} action={handleRefresh} /> :
            thisPost ?
            <>
              <Card elevation={2} className={classes.postCard}>
                <CardContent>
                  <Grid container spacing={4} alignItems='flex-start' justifyContent='space-evenly'>
                    <Grid container item sm={6} direction='column'>
                      
                       <Grid container item xs={12}
                            style={{ borderBottom: 'solid 1px #ccc', marginTop: 8, marginBottom: 8 }}
                            alignItems='center'>
                          <Grid item xs={1}>
                          {(thisPost.friendData.length + thisPost.initialLikers.length > 0)?(
                      <ThumbUpAltOutlinedIcon className={classes.postCardIcon} style={{ color: blue[700], cursor: 'pointer' }} />
                      ):<></>}
                          </Grid>
                          <Grid item xs='auto'>
                            <Typography variant='body1'>
                              <strong>
                                {(thisPost.friendData.length > 0) &&
                                <>
                                
                                {thisPost.friendData.join(', ')}
                                {(thisPost.initialLikers.length > 0) ? ' and ' : ' liked this'}
                                
                                </>
                                }
                                { (thisPost.initialLikers.length > 0) ? (
                                    
                                    thisPost.initialLikers.length
                                    + ((thisPost.friendData.length > 0) ? ' others' : ' people')
                                    + ' liked this'

                                ):

                                      ''

                                  
                                }
                              </strong>
                            </Typography>
                          </Grid>
                      </Grid>
                      
                      
                      <Grid item xs={12}>
                        <CardHeader
                          avatar={
                            // <img alt='account-avatar' className={classes.avatar}
                            //   src={`data:image/png;base64,${new Identicon(thisPost.authorData.id, 40).toString()}`}
                            // />
                            <AccountCircle style={{ color: grey[500], fontSize: 40 }} />
                          }
                          title={
                            <Typography variant='subtitle1'>
                              {thisPost.type === 'shared' && 'Shared by '}
                              {thisPost.authorData.name}
                            </Typography>
                          }
                          subheader={
                            <Typography variant='caption' color='textSecondary'>
                              {thisPost.is_ad==="Y"
                              ? 'Sponsored'
                              : thisPost.post_subtitle
                              }
                            </Typography>
                          }
                        />
                      </Grid>


                        
                      <Grid item style={{ marginTop: 16, marginBottom: 16 }}>
                        <Typography variant='body1' className={classes.paragraph} paragraph>
                          {thisPost.content + ' '}
                          
                        </Typography>
                        {thisPost.attachments.length ?
                          <ImageList cols={1} rowHeight={250} className={classes.postCardImageList}>
                            {thisPost.attachments.map(a => (
                              <ImageListItem key={a.url} component={Link}
                                href={a.url} target='_blank'
                              >
                                <img src={a.url} alt='' style={{ objectFit: 'contain', height: 250 }} />
                              </ImageListItem>
                            ))}
                          </ImageList> :
                          <></>
                        }
                      </Grid>

                      <Grid xs={4}>
                            
                            {
                             thisPost.is_buynow_message==="Y"
                             ? <button class='my-button' onClick={handleButtonClicking} >{thisPost.button_message.Y}</button>
                             : <button class='my-button' onClick={handleButtonClicking} >{thisPost.button_message.N}</button>
                            }
                               
                            
 
                      </Grid>


                      <Grid container item spacing={1} justifyContent='flex-start'>
                        
                        {(thisPost.likers.has(curUser.prolificId) || thisPost.purchasers.has(curUser.prolificId)) &&
                          <Grid container item spacing={1} xs={12} alignItems='center' justifyContent='center'
                            style={{ borderTop: 'solid 1px #ccc', borderBottom: 'solid 1px #ccc', marginTop: 8, marginBottom: 8 }}
                          > {thisPost.purchasers.has(curUser.prolificId) &&
                            <Grid container item xs>
                                <DoneIcon className={classes.postCardIcon} style={{ color: blue[700] }} />
                                <Typography variant='body1'><strong>{thisPost.ad_post_question_message}</strong></Typography>
                            </Grid>
                            }
                            {thisPost.likers.has(curUser.prolificId) &&
                              <Grid container item xs>
                                <ThumbUpOffAltIcon className={classes.postCardIcon} style={{ color: blue[700] }} />
                                <Typography variant='body1'><strong>You liked this</strong></Typography>
                              </Grid>
                            }

                          </Grid>
                        }
                      </Grid>
                    </Grid>
                    <Grid container item spacing={2} xs={12} sm={6} direction='column'>
                      <Grid item>
                        <Typography variant='body2' color='textSecondary' paragraph>
                          On a scale of 1 (strongly disagree) to 5 (strongly agree), please share your opinion about this post:
                        </Typography>
                      </Grid>
                      <Grid container item justifyContent='flex-end'>
                        {options.map((op, i) => (
                          <Grid item xs key={i}>
                            <Typography variant='subtitle2' align='center'>{op}</Typography>
                          </Grid>
                        ))}
                      </Grid>
                      <Grid container item style={{ overflowY: 'auto', height: (expanded ? 500 : 400) }}>
                        {questions.map((q, i) => (
                          <Grid container item key={q.id} style={{ borderTop: '1px solid #ccc' }}>
                            <Grid item xs={12}>
                              <Typography variant='body2'>{q.question}</Typography>
                            </Grid>
                            <Grid container item xs={12} justifyContent='flex-end'>
                              {Array(6).fill(0).map((_, j) => (
                                <Grid key={j} container item xs justifyContent='center'>
                                  <Tooltip title={options[j]}>
                                    <Radio
                                      size='small'
                                      checked={q.selectedOption === `${j + 1}`}
                                      onChange={e => chooseOption(i, e.target.value)}
                                      value={`${j + 1}`}
                                    />
                                  </Tooltip>
                                </Grid>
                              ))}
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                      <Grid container item justifyContent='center' style={{ borderTop: '1px solid #ccc' }}>
                        {allSelectedMessage && <Typography variant='body2' color='error'>{allSelectedMessage}</Typography>}
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              <ContinueCard action={handleSubmit} />
            </>
            : <></>
        }
      </Container>
    </div>
  )
}

export default AdPostQuestionCard
